import { ServerError, ServerParseError } from '@apollo/client/errors'

/**
 * The HTTP status the server responded with, or undefined when the request never got a response
 * (offline, DNS/TLS failure, blocked by an extension) or `error` is anything else. Accepts
 * `unknown` so call sites need no guard.
 *
 * A status means the server *did* respond, so this is the check to branch on for 401/5xx handling,
 * rather than the mere presence of a network error. Some browsers report 0 for a request blocked
 * before it left the machine; that is passed through as-is, and {@link isNetworkError} is what
 * treats it as unreachable.
 */
export const getNetworkStatusCode = (error: unknown): number | undefined =>
  ServerError.is(error) || ServerParseError.is(error) ? error.statusCode : undefined
